import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';

export default function DropdownMenu({ show, children, onClick }) {
    return (
        <>
            <Overlay show={show} onClick={onClick} />
            <Transition
                show={show}
                enter="transition duration-75 z-20 absolute inset-0"
                enterFrom="opacity-0 absolute"
                enterTo="opacity-100 absolute"
                leave="transition duration-150 z-20 absolute inset-0 absolute"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="absolute bg-white shadow-lg py-3 rounded w-44 top-8 right-0 z-40">
                    {children}
                </div>
            </Transition>
        </>
    );
}

export function DropdownMenuItem({
    children,
    to,
    className = 'text-gray-800 hover:text-gray-900',
    ...props
}) {
    return (
        <a
            {...props}
            href={to}
            className={classNames(
                'block hover:bg-blue-gray-50 active:bg-blue-gray-100 cursor-pointer px-5 py-1 heading-5 w-full text-left focus:outline-none focus-visible:ring-2',
                className,
            )}
        >
            {children}
        </a>
    );
}

function Overlay({ onClick, show }) {
    return (
        <Transition
            show={show}
            as={Fragment}
            enter="transition duration-150"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
        >
            <div
                tabIndex={-1}
                role="button"
                className="z-40 inset-0 bg-opacity-40 bg-transparent fixed top-0 left-0 h-full w-full"
                onClick={onClick}
            ></div>
        </Transition>
    );
}
